exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".EditMessageDialog_content__2_G1L {\n  width: 400px; }\n", ""]);

// exports
exports.locals = {
	"content": "EditMessageDialog_content__2_G1L"
};